import React, { useState, useContext } from "react";
import { MobileMenuContainer } from "./MobileMenuStyled";

import { Link, useNavigate } from "react-router-dom";
import { FormattedMessage } from 'react-intl';
import { UserContext } from "../../../context/userContext";



export default function MobileMenu({ setShowMenu }) {


    let navigate = useNavigate();
    const [showSettingsMenu, setShowSettingsMenu] = useState(false);

    const { userToken, setUserToken, userType, setUserType, uniqueName } = useContext(UserContext);

    const isAdmin = sessionStorage.getItem('isAdmin');

    const handlerCloseMenu = () => {
        setShowMenu(false)
    }

    const handlerLogout = () => {
        setShowSettingsMenu(false);
        localStorage.removeItem('fluincrToken');
        localStorage.removeItem('fluincrUser');
        sessionStorage.removeItem('fluincrToken');
        sessionStorage.removeItem('fluincrUser');
        setUserToken(null);
        setUserType('');
        navigate('/');
    }

    return (
        <MobileMenuContainer>
            <div className="outsideMenu" onClick={handlerCloseMenu}>

            </div>
            <div className="lateralMenu">
                <ul className="options">
                    <Link to={`/${uniqueName}`}>
                        <li><FormattedMessage id="burger_menu_option_1" defaultMessage="Mi perfil" /></li>
                    </Link>

                    {(userType === 'company' && !isAdmin) && (<><hr />
                        <Link to={'/mycart'}>
                            <li><FormattedMessage id="burger_menu_option_2" defaultMessage="Mi carrito" /></li>
                        </Link></>)}


                    <hr />
                    <Link to={'/mycollaborations'}>
                        <li ><FormattedMessage id="burger_menu_option_3" defaultMessage="Colaboraciones" /></li>
                    </Link>

                    <hr />
                    <li onClick={() => { setShowSettingsMenu(!showSettingsMenu) }}><FormattedMessage id="burger_menu_option_4" defaultMessage="Configuración" /></li>
                    <hr />
                    {(showSettingsMenu) && (
                        <div className="settingsMenu" >
                            <Link to='myprofile'>
                                <p className="settingsOption" onClick={() => { setShowSettingsMenu(false) }}><FormattedMessage id="settings_menu_option_1" defaultMessage="Editar mi perfil" /></p>
                            </Link>

                            <hr />
                            <Link to='myaccount'>
                                <p className="settingsOption" onClick={() => { setShowSettingsMenu(false) }}><FormattedMessage id="settings_menu_option_2" defaultMessage="Editar mi cuenta" /></p>
                            </Link>
                            <hr />

                            {/* {(!isAdmin) && (<>
                                <p className="settingsOption" onClick={() => { setShowSettingsMenu(false) }}><FormattedMessage id="settings_menu_option_3" defaultMessage="Mis favoritos" /></p>
                                <hr />
                            </>)} */}

                            {/* <p className="settingsOption" onClick={() => { setShowSettingsMenu(false) }}><FormattedMessage id="settings_menu_option_4" defaultMessage="Mis pagos" /></p>
                            <hr /> */}
                            <p className="settingsOption" onClick={handlerLogout}><FormattedMessage id="settings_menu_option_5" defaultMessage="Cerrar sesión" /></p>
                        </div>
                    )}

                </ul>
            </div>
        </MobileMenuContainer>
    )
}